import * as types from './PlansCoverageTypes';

export default function PlansCoverageReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PLANS_COVERAGE:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    plansCoverage: payload.data,
                    firstPlanCoverage: payload.first,
                    lastPlanCoverage: payload.last,
                    nextPlansCoverage: payload.next,
                    plansCoverageFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PLANS_COVERAGE_LOADING:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    loading: true
                },
            };
        case types.GET_PLANS_COVERAGE_ERROR:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_PLANS_COVERAGE_FILTER:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    plansCoverageFilter: payload.data,
                    firstPlanCoverage: payload.first,
                    lastPlanCoverage: payload.last,
                    nextPlansCoverage: payload.next,
                    loading: false
                },
            };
        case types.GET_PLANS_COVERAGE_FILTER_LOADING:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    loading: true
                },
            };
        case types.GET_PLANS_COVERAGE_FILTER_ERROR:
            return {
                ...state,
                getPlansCoverage: {
                    ...state.getPlansCoverage,
                    plansCoverageFilter: [],
                    loading: false
                },
            };
        case types.GET_PLANS_COVERAGE_BY_ID:
            return {
                ...state,
                getPlansCoverageById: {
                    ...state.getPlansCoverageById,
                    planCoverage: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PLANS_COVERAGE_BY_ID_LOADING:
            return {
                ...state,
                getPlansCoverageById: {
                    ...state.getPlansCoverageById,
                    loading: true,
                },
            };
        case types.GET_PLANS_COVERAGE_BY_ID_ERROR:
            return {
                ...state,
                getPlansCoverageById: {
                    ...state.getPlansCoverageById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_PLAN_COVERAGE:
            return {
                ...state,
                createPlanCoverage: {
                    ...state.createPlanCoverage,
                    plan: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PLAN_COVERAGE_LOADING:
            return {
                ...state,
                createPlanCoverage: {
                    ...state.createPlanCoverage,
                    loading: true
                },
            };
        case types.CREATE_PLAN_COVERAGE_ERROR:
            return {
                ...state,
                createPlanCoverage: {
                    ...state.createPlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_PLAN_COVERAGE_RESET_STATE:
            return {
                ...state,
                createPlanCoverage: {
                    ...state.createPlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PLAN_COVERAGE:
            return {
                ...state,
                updatePlanCoverage: {
                    ...state.updatePlanCoverage,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PLAN_COVERAGE_LOADING:
            return {
                ...state,
                updatePlanCoverage: {
                    ...state.updatePlanCoverage,
                    loading: true
                },
            };
        case types.UPDATE_PLAN_COVERAGE_ERROR:
            return {
                ...state,
                updatePlanCoverage: {
                    ...state.updatePlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PLAN_COVERAGE_RESET_STATE:
            return {
                ...state,
                updatePlanCoverage: {
                    ...state.updatePlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_COVERAGES:
            return {
                ...state,
                updateCoverages: {
                    ...state.updateCoverages,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_COVERAGES_LOADING:
            return {
                ...state,
                updateCoverages: {
                    ...state.updateCoverages,
                    loading: true
                },
            };
        case types.UPDATE_COVERAGES_ERROR:
            return {
                ...state,
                updateCoverages: {
                    ...state.updateCoverages,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_COVERAGES_RESET_STATE:
            return {
                ...state,
                updateCoverages: {
                    ...state.updateCoverages,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.DELETE_PLAN_COVERAGE:
            return {
                ...state,
                deletePlanCoverage: {
                    ...state.deletePlanCoverage,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.DELETE_PLAN_COVERAGE_LOADING:
            return {
                ...state,
                deletePlanCoverage: {
                    ...state.deletePlanCoverage,
                    loading: true
                },
            };
        case types.DELETE_PLAN_COVERAGE_ERROR:
            return {
                ...state,
                deletePlanCoverage: {
                    ...state.deletePlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_PLAN_COVERAGE_RESET_STATE:
            return {
                ...state,
                deletePlanCoverage: {
                    ...state.deletePlanCoverage,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.PLANS_COVERAGE_RESET_STATE:
            return {
                getPlansCoverage: {
                    plansCoverage: [],
                    firstPlanCoverage: null,
                    lastPlanCoverage: null,
                    nextPlansCoverage: null,
                    plansCoverageFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getPlansCoverageById: {
                    planCoverage: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                createPlanCoverage: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updatePlanCoverage: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateCoverages: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                deletePlanCoverage: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
    
        default:
            return state;
    }
}